import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; 
const WhatsAppButton = () => {
  const phoneNumber = '+5512991149709';

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={30} />
    </a>
  );
};

export default WhatsAppButton;
